import React from 'react';

const IcRespondAnchor = ({ id, pendingIds = [], children }) => {
  const active = pendingIds.includes(id);
  return (
    <div
      id={`ic-respond-${id}`}
      className={active ? 'rounded-3 border border-danger border-2' : undefined}
      style={{ scrollMarginTop: 96 }}
    >
      {children}
    </div>
  );
};

export default IcRespondAnchor;
